export * from './infinite-scroll-table.component';
export * from './infinite-scroll-table.module';
